export default {
    data() {
        return {

        };
    },

    methods: {

    },

    computed: {
        FrontendConfig() {
            return this.$store.getters['FrontendConfig'];
        },
        AddedFields() {
            if (this.FrontendConfig && this.FrontendConfig.AddedFields) {
                return this.FrontendConfig.AddedFields;
            }
            else {
                return null;
            }
        },
    },
}